module.exports = __webpack_public_path__ + "static/media/logo_rediseg.b31b2946.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo_rediseg.svg
// module id = 529
// module chunks = 0